import React from "react";
import { useLocation, Link } from "react-router-dom";

import { useSelector } from 'react-redux';

import { Badge, Menu, Tag } from "antd";

import navigation from "../../../../navigation/vertical";
import usePendingRequestCounts from "../../../../hooks/usePendingRequestCounts";

const { SubMenu } = Menu;

const BADGE_RED = '#ff4d4f';

// The menu row clips whatever leaves its box, so the counter stays inside it:
// no negative margins, and it never shrinks when the label is long.
const MENU_LINK_STYLE = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    width: '100%',
};

const MENU_TITLE_STYLE = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};

const PENDING_BADGE_STYLE = {
    flex: '0 0 auto',
    minWidth: 20,
    height: 20,
    padding: '0 6px',
    borderRadius: 10,
    background: BADGE_RED,
    color: '#fff',
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '20px',
    textAlign: 'center',
};

export default function MenuItem(props) {
    const { onClose } = props;

    // Redux
    const customise = useSelector(state => state.customise)

    // Waiting-for-moderation counters, keyed by menu item id
    const pendingCounts = usePendingRequestCounts();

    // Location
    const location = useLocation();
    const { pathname } = location;

    const splitLocation = pathname.split("/")

    // Menu
    const splitLocationUrl =
        splitLocation[splitLocation.length - 2] +
        "/" +
        splitLocation[splitLocation.length - 1];

    const menuItem = navigation.map((item, index) => {
        if (item.header) {
            return <Menu.ItemGroup key={index} title={item.header}></Menu.ItemGroup>;
        }

        if (item.children) {
            return (
                <SubMenu key={item.id} icon={item.icon} title={item.title}>
                    {item.children.map((itemChildren, index) => {
                        if (!itemChildren.children) {
                            const childrenNavLink = itemChildren.navLink.split("/");

                            return (
                                // Level 2
                                <Menu.Item
                                    key={itemChildren.id}
                                    className={
                                        splitLocationUrl ===
                                            childrenNavLink[childrenNavLink.length - 2] +
                                            "/" +
                                            childrenNavLink[childrenNavLink.length - 1]
                                            ? "ant-menu-item-selected"
                                            : "ant-menu-item-selected-in-active"
                                    }
                                    onClick={onClose}
                                >
                                    <Link to={itemChildren.navLink}>{itemChildren.title}</Link>
                                </Menu.Item>
                            );
                        } else {
                            return (
                                // Level 3
                                <SubMenu key={itemChildren.id} title={itemChildren.title}>
                                    {itemChildren.children.map((childItem, index) => {
                                        const childrenItemLink = childItem.navLink.split("/");

                                        return (
                                            <Menu.Item
                                                key={childItem.id}
                                                className={
                                                    splitLocationUrl ===
                                                        childrenItemLink[childrenItemLink.length - 2] +
                                                        "/" +
                                                        childrenItemLink[childrenItemLink.length - 1]
                                                        ? "ant-menu-item-selected"
                                                        : "ant-menu-item-selected-in-active"
                                                }
                                                onClick={onClose}
                                            >
                                                <Link to={childItem.navLink}>{childItem.title}</Link>
                                            </Menu.Item>
                                        );
                                    })}
                                </SubMenu>
                            );
                        }
                    })}
                </SubMenu>
            );
        } else {
            const itemNavLink = item.navLink ? item.navLink.split("/") : '';

            return (
                // Level 1
                <Menu.Item
                    key={item.id}
                    icon={
                        // A collapsed sidebar hides the label, so the counter
                        // moves onto the icon as a plain dot
                        pendingCounts[item.id] > 0 && customise.sidebarCollapsed ? (
                            <Badge dot offset={[0, 2]} color={BADGE_RED}>
                                {item.icon}
                            </Badge>
                        ) : (
                            item.icon
                        )
                    }
                    onClick={onClose}
                    className={
                        splitLocation[splitLocation.length - 2] +
                            "/" +
                            splitLocation[splitLocation.length - 1] ===
                            itemNavLink[itemNavLink.length - 2] +
                            "/" +
                            itemNavLink[itemNavLink.length - 1]
                            ? "ant-menu-item-selected"
                            : "ant-menu-item-selected-in-active"
                    }
                    style={item.tag && { pointerEvents: 'none' }}
                >
                    {
                        pendingCounts[item.id] > 0 ? (
                            <Link to={item.navLink} style={MENU_LINK_STYLE}>
                                <span style={MENU_TITLE_STYLE}>{item.title}</span>
                                <span style={PENDING_BADGE_STYLE}>
                                    {pendingCounts[item.id] > 99 ? '99+' : pendingCounts[item.id]}
                                </span>
                            </Link>
                        ) : item.tag ? (
                            <a href="#" className="hp-d-flex hp-align-items-center hp-d-flex-between">
                                <span>{item.title}</span>
                                <Tag className="hp-mr-0 hp-border-none hp-text-color-black-100 hp-bg-success-3 hp-border-radius-full hp-px-8" style={{ marginRight: -14 }}>{item.tag}</Tag>
                            </a>
                        ) : (
                            <Link to={item.navLink}>{item.title}</Link>
                        )
                    }
                </Menu.Item>
            );
        }
    })

    return (
        <Menu
            mode="inline"
            defaultOpenKeys={[
                splitLocation.length === 5
                    ? splitLocation[splitLocation.length - 3]
                    : null,
                splitLocation[splitLocation.length - 2],
            ]}
            theme={customise.theme === "light" ? "light" : "dark"}
            className="hp-bg-black-20 hp-bg-dark-90"
        >
            {menuItem}
        </Menu>
    );
};